import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import {
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
} from "./shared";
import { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";

// Черепаха (#35) — Крупный: тетра-пак, трубочка с крышечкой, пакет
export const TURTLE_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/package2.glb"),
  new GLBModel("/models/garbage/cap.glb"),
  new GLBModel("/models/garbage/pack.glb"),
];

export const TURTLE_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -1.65, y: -2.28, z: -1.15 },
    rotation: { x: 0, y: 0.42, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: -2.5, y: -3.35, z: -3.6 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 5.45, y: 4.8, z: 1.8 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: -2.32, y: -3.75, z: -6.75 },
    rotation: { x: 0, y: -0.873, z: 0 },
    scale: { x: 7.3, y: 4.8, z: 5.1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: 2.55, y: -3.35, z: -5.55 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 5.45, y: 4.8, z: 5.1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.7,
    position: { x: -0.05, y: -3.6, z: -3.42 },
    rotation: { x: 0.053, y: -1.135, z: -0.036 },
    scale: { x: 4, y: 3.8, z: 2.2 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: 1.7, y: -2.75, z: -2.35 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 3.1, y: 2.2, z: 3.15 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: 1.05, y: -2.75, z: 1.4 },
    rotation: { x: 0, y: -1.047, z: 0 },
    scale: { x: 3.1, y: 2.2, z: 3.15 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.7,
    position: { x: -2.95, y: -3.2, z: -1.1 },
    rotation: { x: 0, y: -1.047, z: 0 },
    scale: { x: 3.1, y: 2.2, z: 3.15 },
  },
];

export const TURTLE_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  pollutionColor: "#608b85",
}
